export enum TitaniaTransactionGlancerStepTypeEnum {
    PlanStep = 1,
    NonPlanTransactionStep = 2,
    ChooseMyBenefits = 3,
    Total = 4,
    Entry = 5,
    Compare = 6,
    Confirm = 7,
    Beneficiary = 8,
    Certify = 9,
    FamilyLifeEvent = 10,
    Survey = 11,
    Tobacco = 12,
    ConfirmElections = 13,
    PlanQuestions = 14,
    Waive = 15,
}
